// import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { v4 as uuidv4 } from "uuid";
import { promptedState, selectedPromptState } from "../../utils/recoil";
import { IoIosClose } from "react-icons/io";
import { RxReload } from "react-icons/rx";

const PromptInputBox = ({
  setAnswers,
  setPrompt,
  handleSubmit,
  prompt,
  isLoading,
}) => {
  //   const [selectedCity, setSelectedCity] = useState(null);

  //   const cities = [
  //     { name: "New York", code: "NY" },
  //     { name: "Rome", code: "RM" },
  //     { name: "London", code: "LDN" },
  //     { name: "Istanbul", code: "IST" },
  //     { name: "Paris", code: "PRS" },
  //   ];

  const handleClearChat = (e) => {
    e.preventDefault();
    // clear the chats
    setAnswers([]);
  };

  return (
    <div className="absolute bottom-5 flex flex-col justify-between left-1/2 -translate-x-1/2 pl-3 w-[45rem] md-max:w-[90%] md-max:max-w-[45rem] h-24 bg-[#E8F1FF] border-8 border-[#a6c5f8] rounded-xl">
      <form onSubmit={handleSubmit} className="flex gap-3">
        <div className="w-full">
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            className="w-full bg-transparent !outline-none p-2 h-full !text-sm rounded-md flex-wrap overflow-scroll no-scrollbar"
            placeholder="Type your prompt here"
          />
        </div>
        <div className="flex flex-col gap-1 p-1">
          <button
            disabled={isLoading}
            type="submit"
            className="bg-[#69A6FF] border border-[#E0ECFF] p-2 rounded-md size-8"
          >
            {isLoading ? (
              <RxReload className="text-[#E0ECFF]" size={14} />
            ) : (
              <FaArrowUp className="text-[#E0ECFF]" size={14} />
            )}
          </button>
        </div>
      </form>

      {/* <div>
        <Dropdown
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.value)}
          options={cities}
          optionLabel="name"
          placeholder="Gemini"
          className="w-max bg-transparent border-transparent !outline-none [&_span]:!text-xs [&>div>svg>path]:!fill-[#e2bad1] [&>.p-dropdown-trigger]:scale-80 [&_span]:!text-[#e2bad1]"
        />
      </div> */}
    </div>
  );
};

export default PromptInputBox;
